<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("_SUPPORT.TITLE") }}</h4>
    </div>
    <div class="grid-body p-3 border-top-unset">
      <div id="connect">
          <div class="content-wrapper d-flex flex-column" v-html="$t('_CONFIGURATION.BE_SUPPORT')">
          </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#connect {
    .content-wrapper{
        .header-title{
            font-size: 24px;
        }
        img {
          width: 100%;
          max-width: 100%;
          padding-bottom: 15px;
        }
        textarea {
          width: 100%;
          background: #fff;
          border-radius: 5px;
          resize: none;
          &:focus {
            outline: none;
          }
        }
        button {
          padding: 10px 32px;
          border-radius: 8px;
          font-size: 0.9rem;
          background: #173d8f;
          color: #ffff;
        }
    }
  .card-item-content {
    padding: 9px 16px;
  }
  .card-title {
    font-weight: bold;
    font-size: 10px;
    height: 24px;
    line-height: 24px;
    color: rgba(38, 38, 38, 0.5);
    margin: 0;
    text-transform: uppercase;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
</style>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import { service } from "@/_services/Dashboard/dashboard.service.js";
import { _alert } from "@/_helpers/function.js";
import moment from "moment";

export default {
  components: {
    "page-header": PageHeader,
    "left-menu": LeftMenu,
  },
  data() {
    return {
      currentUser: JSON.parse(localStorage.getItem("currentUser")),
    };
  },
  created() {
   
  },
  methods: {
    copy_to_clipboard(id)
      {
          document.getElementById(id).select();
          document.execCommand('copy');
          const a = {
            responseCode: 0,
          };
           _alert(a, this.$t('COPYED'), false);
      },
  },
};
</script>